import { useNavigate } from 'react-router-dom';

import { PageTitle } from '@oysterjs/uiv2/page';
import { SignOutMutation, SignOutMutationVariables, SignOutDocument } from '../../api/graphql';
import { Button } from '@oysterjs/uiv2/button';
import { PageNavigation } from '@oysterjs/uiv2/navigation';
import { client } from '../../api/client';

export const SettingsPage = () => {
  const navigate = useNavigate();
  const signOut = async () => {
    const res = await client.mutate<SignOutMutation, SignOutMutationVariables>({
      mutation: SignOutDocument
    });
    if (res.data?.agencySignOut) {
      navigate('/app/signin');
    }
  };

  return (
    <PageTitle
      title="Settings"
      description="Configure and manage your account"
      menu={
        <Button color="white" onClick={signOut}>
          Sign out
        </Button>
      }
    >
      <div className="-mt-2">
        <PageNavigation
          routes={[
            {
              path: 'subscription',
              title: 'Subscription'
            },
            {
              path: 'integrations',
              title: 'Integrations'
            }
          ]}
        />
      </div>
    </PageTitle>
  );
};
